import React from 'react'
import {makeStyles} from '@material-ui/styles'
import {complement, converge, ifElse, join, nthArg, prop, unapply} from 'ramda'

const useStyles = makeStyles({
  root: {
    opacity: 0,
    transition: 'opacity 1s ease-out',
    fontSize: '0.8em',
    display: 'inline-block'
  },
  visible: {
    opacity: 1,
    transition: 'opacity 0s ease-out'
  },
})

export default function Message({visible, ...props}) {
  const classes = useStyles()
  return <span className={getClassName(classes, visible)} {...props} />
}

const getClassName = ifElse(
  complement(nthArg(1)),
  prop('root'),
  converge(unapply(join(' ')), [prop('root'), prop('visible')]),
)